/*
 * IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA
 * GOVERNMENT - GOVERNMENT - GOVERNMENT - GOVERNMENT - GOVERNMENT
 *
 * Copyright: 2023 by Idemia Identity & Security USA LLC. All rights reserved.
 * License: In accordance  Idemia I&S USA LLC's license agreement.
 * Code Classification: GOVERNMENT
 *
 * Classification Person: Nadim Bakizada nadim.bakizada@us.idemia.com
 * Classification Reason: Software not specific to any U.S. Government Entity
 * Classification Date: 2023
 *
 * GOVERNMENT - GOVERNMENT - GOVERNMENT - GOVERNMENT - GOVERNMENT
 * IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA IDEMIA
 */

import dayjs from 'dayjs'
const utc = require('dayjs/plugin/utc')
const timezone = require('dayjs/plugin/timezone')
const tz = "America/California"

export const formatDate = (date: Date | string | number) => {
    return dayjs(date).format("MM/DD/YYYY");
}

export const formatBirthDate = (date: string, format: string) => {
    if (!date) return "N/A";

    if (/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(date)) {
        return dayjs(date, ["M/D/YYYY", "MM/DD/YYYY"], true).format("MM/DD/YYYY");
    }

    if (/^\d{8}$/.test(date)) {
        return dayjs(date, format).format("MM/DD/YYYY");
    }

    const parsed = dayjs(date, format);
    return parsed.isValid() ? parsed.format("MM/DD/YYYY") : "Invalid Date";
};
